module.exports = __webpack_public_path__ + "images/emoji/books.bc86e7d55e71d56688f8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/books.png
// module id = sg3U
// module chunks = 2